import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./SideMenu.css";
import Hero from "../Hero/Hero";

const SideMenu = () => {
  const [activeMenuItem, setActiveMenuItem] = useState();

  useEffect(() => {
    //To assign the classname in page refresh or direct link
    const currentPath = window.location.pathname;
    if (currentPath !== "/pest-information") {
      handleActiveMenu();
    }
  }, []);

  //Function to handle click on menu items
  const handleActiveMenu = () => {
    setActiveMenuItem("usa-sidenav__itemmain active");
  };

  return (
    <>
      <Hero value="Pest Information" />
      <div className="grid-container pest-sidenav">
        <section className="grid-row grid-gap-3">
          <aside className="desktop:grid-col-3 margin-top-2 layout-sidebar-first">
            <h2 className="heading">Pest Information</h2>
            <nav aria-label="Secondary navigation">
              <ul className="usa-sidenav">
                <li className="usa-sidenav__item">
                  <NavLink
                    end
                    to="/pest-information"
                    onClick={() => setActiveMenuItem("usa-sidenav__item")}
                  >
                    Pests of National Concern
                  </NavLink>
                </li>
                <li className="usa-sidenav__item">
                  <NavLink
                    className={activeMenuItem + " no-top-border"}
                    to="/pest-information/by-pest"
                  >
                    Pest Impact Tables
                  </NavLink>
                  <ul className="usa-sidenav__sublist">
                    <li className="usa-sidenav__subitem">
                      <NavLink to="/pest-information/by-pest">By Pest</NavLink>
                    </li>
                    <li className="usa-sidenav__subitem">
                      <NavLink
                        to="/pest-information/by-state"
                        onClick={() => handleActiveMenu()}
                      >
                        By State
                      </NavLink>
                    </li>
                    <li className="usa-sidenav__subitem">
                      <NavLink
                        to="/pest-information/by-region"
                        onClick={() => handleActiveMenu()}
                      >
                        By Forest Service Region
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
          <div className="desktop:grid-col-9">
            <Outlet />
          </div>
        </section>
      </div>
    </>
  );
};

export default SideMenu;
